import { all, takeEvery, fork, call, put } from "redux-saga/effects";
import { proposalSlideSettingService } from "@iso/services";
import actions from "./actions";

function* searchSettings() {
  yield takeEvery(actions.SEARCH_REQUEST, function* ({ payload }) {
    const { keyword, facilityCredentialIds, enabled, latestStatus, page, size, resolve, reject } = payload;
    try {
      const response = yield call(proposalSlideSettingService.search, {
        keyword,
        facilityCredentialIds,
        enabled,
        latestStatus,
        page,
        size,
      });
      resolve && resolve(response);
      yield put({
        type: actions.SEARCH_SUCCESS,
        items: response?.items ?? [],
        total: response?.total ?? 0,
      });
    } catch (e) {
      yield put({ type: actions.SEARCH_ERROR, error: e });
      reject && reject(e);
    }
  });
}

function* getDetail() {
  yield takeEvery(actions.DETAIL_REQUEST, function* ({ payload }) {
    const { proposalSlideSettingId, resolve, reject } = payload;
    try {
      const response = yield call(proposalSlideSettingService.getDetail, {
        proposalSlideSettingId,
      });
      resolve && resolve(response);
      yield put({ type: actions.DETAIL_SUCCESS, detail: response });
    } catch (e) {
      yield put({ type: actions.DETAIL_ERROR });
      reject && reject(e);
    }
  });
}

function* createSetting() {
  yield takeEvery(actions.CREATE_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload;
    try {
      const response = yield call(proposalSlideSettingService.create, data);
      yield put({ type: actions.CREATE_SUCCESS });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.CREATE_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* updateSetting() {
  yield takeEvery(actions.UPDATE_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload;
    try {
      const response = yield call(proposalSlideSettingService.update, data);
      yield put({ type: actions.UPDATE_SUCCESS });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.UPDATE_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* deleteSetting() {
  yield takeEvery(actions.DELETE_REQUEST, function* ({ payload }) {
    const { proposalSlideSettingId, resolve, reject } = payload;
    try {
      const response = yield call(proposalSlideSettingService.delete, {
        proposalSlideSettingId,
      });
      yield put({ type: actions.DELETE_SUCCESS });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.DELETE_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* executeSetting() {
  yield takeEvery(actions.EXECUTE_REQUEST, function* ({ payload }) {
    const { proposalSlideSettingId, resolve, reject } = payload;
    try {
      const response = yield call(proposalSlideSettingService.execute, {
        proposalSlideSettingId,
      });
      yield put({ type: actions.EXECUTE_SUCCESS });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.EXECUTE_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(searchSettings),
    fork(getDetail),
    fork(createSetting),
    fork(updateSetting),
    fork(deleteSetting),
    fork(executeSetting),
  ]);
}
